<template>
    <detail-form
        v-model="ibeaconForm">
        <template v-slot:content="{ form }">
            <detail-form-item
                disabled
                cols="6"
                type="text"
                v-model="form.uuid"
                :label="$t('ibeacon.details.uuid')"/>

            <detail-form-item
                required
                cols="6"
                type="text"
                v-model="form.name"
                :label="$t('ibeacon.details.name')"/>
            <detail-form-item
                disabled
                cols="6"
                type="number"
                v-model="form.major"
                :label="$t('ibeacon.details.major')"/>
            <detail-form-item
                disabled
                cols="6"
                type="number"
                v-model="form.minor"
                :label="$t('ibeacon.details.minor')"/>
            <detail-form-item
                cols="12"
                type="textarea"
                v-model="form.remark"
                :label="$t('ibeacon.details.remark')"/>
            <detail-form-section
                cols="12"
                :text="$t('ibeacon.details.broadcastMessage')"/>
            <detail-form-item
                required
                return-object
                cols="12"
                type="selectRelation"
                item-value="id"
                item-text="message"
                v-model="form.broadcastMessage"
                :label="$t('ibeacon.details.message')"
                :items="selectableMessages"/>
        </template>
    </detail-form>
</template>

<script>
import DetailForm from '@/components/forms/DetailForm'
import DetailFormItem from '@/components/forms/DetailFormItem'
import DetailFormSection from '@/components/forms/DetailFormSection'

import { mapState } from 'vuex'

export default {
    name: 'IBeaconDetailsView',

    model: {
        prop: 'ibeacon',
        event: 'input'
    },

    props: {
        ibeacon: {
            type: Object,
            default: () => {}
        }
    },

    components: {
        DetailForm,
        DetailFormItem,
        DetailFormSection
    },

    computed: {
        selectableMessages () {
            const emptyMessage = {
                id: null,
                message: this.$t('noData')
            }

            return [emptyMessage, ...this.messages.map(message => {
                let defaultMessage = this.$t('noData')
                let preferedMessage
                // eslint-disable-next-line
                message?.messages?.forEach(msg => {
                    if (msg.langCode === this.$constant.locale.DEFAULT_IBEACON_LOCALE) {
                        defaultMessage = msg.title
                    }

                    if (msg.langCode === this.$i18n.locale) {
                        preferedMessage = msg.title
                    }
                })
                return {
                    ...message,
                    message: preferedMessage ?? defaultMessage
                }
            })]
        },

        ibeaconForm: {
            get () {
                return this.ibeacon
            },

            set (value) {
                this.$emit('input', value)
            }
        },

        ...mapState('ibeaconMessage', ['messages'])
    },

    mounted () {
        this.fetchIBeaconMessages()
    },

    methods: {
        fetchIBeaconMessages () {
            this.$store.dispatch('ibeaconMessage/fetchIBeaconMessages')
        },

        async save () {
            const { broadcastMessage, ...updateForm } = this.ibeaconForm
            if (!broadcastMessage.id) {
                updateForm.broadcastMessage = null
            } else {
                updateForm.broadcastMessage = broadcastMessage
            }
            await this.$store.dispatch('ibeacon/updateIBeacon', updateForm)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
